export const assessment_update = {
  pre_update_changes_filename:
    "Pre_Update_{{preVersion}}_to_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  post_update_changes_filename:
    "Post_Update_{{preVersion}}_to_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  "Are_you_sure_you_want_to_migrate?": "Are you sure you want to migrate?",
  Assessment_Update_Dry_Run: "Assessment Update",
  Assessment_Update_List: "Assessment Update List",
  Back_to_list: "Back to list",
  Completed: "Completed",
  Created: "Created",
  Current_protocol_set_mapping_version: "Current Protocol Mapping Version",
  Deleted: "Deleted",
  Download_JSON: "Download JSON",
  Download_Report: "Download Report",
  Dry_Run: "Dry Run",
  Has_data: "Has data",
  Inactive: "Inactive",
  Is_renamed: "Is renamed",
  Migrate: "Proceed",
  Migrated: "Migrated",
  No_changes: "No changes",
  No_changes_needed: "No changes needed",
  Protocol_Question_Name: "Protocol Question Name",
  Protocol_Question_New_Name: "Protocol Question New Name",
  Protocol_Question_Old_Name: "Protocol Question Old Name",
  protocol_set_changes: "Protocol Set Changes",
  Run_At: "Run At",
  Run_By: "Run By",
  Site_name: "Site name",
  Stakeholder_Report: "Stakeholder Report",
  Technical_Report: "Technical Report",
  There_are_no_assessments_for_this_tenant: "There are no assessments for this tenant",
  To_create: "To create",
  To_delete: "To delete",
  To_migrate: "To migrate",
  Update: "Update",
  Upgrade_to_latest: "Upgrade to latest",
  Version_Transition: "Version Transition",
  assessment_is_already_updated: "Assessment is already updated",
  show_history: "Show History",
} as const;
